export default __webpack_public_path__ + "static/media/vite.b30f410b.svg";